console.log("init Proteus Treatments 0.14");

// [KIZ-55] v2 -- last chance (hidden for first time users)
if (localStorage.getItem('hasVisited') === null) {
  
  window.localStorage.setItem('hasVisited', 'true');
  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style>
      [aria-label="Last Chance Navigation"],
      nav-menu [href*="https://kizik.com/collections/sale"],
      nav [href*="https://kizik.com/collections/sale"] {
        display: none !important;
      }
      .reveal-first-visit {
        display: block !important;
      }
    </style>
    `);
  }).catch();
  waitForElement('footer [aria-label="Shoes Navigation"] ul li:last-of-type').then(footer_link => {
    footer_link.insertAdjacentHTML("afterend",`
      <li style="display:none;" class="mb-2 last:mb-0 reveal-first-visit" data-index="5"><a href="/collections/sale" class="">Last Chance</a></li>
    `);
  }).catch();
}

// setup for shipping test
observeSelector('.block--accordion', pdp_accordion => {
  if(pdp_accordion.innerText.indexOf("Free Shipping on all US orders") > -1){
    pdp_accordion.classList.add("js-pdp-accordion--free-shipping");
    pdp_accordion.style.display = "none";
  }
});

// only new loyalty subscribers are given free shipping (via proteus app)
if(window.location.href.indexOf("loyalty=email-signup") > -1){
  gtm_add_cartAttribute("proteus-shipping", "v1")    
}

window.addEventListener("klaviyoForms", function(e) { 
  
  // #SvJkvW == [KIZ] loyalty signup
  if (e.detail.formId == "SvJkvW"  && e.detail.type == 'submit') {
    console.log("[KIZ] -- activate free shipping");
    gtm_add_cartAttribute("proteus-shipping", "v1")
  }        

});

////////////////////////////////////////////
// START BFCM 2024 -- CHARCOAL SOCKS GWP //
//////////////////////////////////////////

let enable_bfcm_2024 = false;
let bfcm_2024_gwp_var_id = 37193031483549;
if(enable_bfcm_2024 || window.location.href.indexOf("qa=bfcm") > -1 || window.sessionStorage.getItem("BFCM 2024")){

  window.sessionStorage.setItem("BFCM 2024", "active");
  
  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style>
    
    .js-cart--banner{
      display: none;
      background: #0022B5;
      padding: .5em;
      text-align: center;
      color: #fff;
      
    }

    cart-wrapper footer{
      position: relative;
    }
    
    .js-cart--checkout-button-mask{
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    #js-socks-gwp{
      display: none;
    }
    
    body[data-add-promo-item] #js-socks-gwp,
    body[data-promo-item-added] .js-cart--banner,
    body[data-add-promo-item] .js-cart--banner,
    body[data-add-promo-item] .js-cart--checkout-button-mask{
      display: block;
    }
    </style>
    `);
  

    observeSelector('cart-wrapper header', cart => {
      // if(document.querySelectorAll('.js-cart--banner').length == 0){
      // }
      cart.insertAdjacentHTML("beforeend", `
        <div class="js-cart--banner">
           Score! Free socks added to your cart.
        </div>
      `);
      cart.insertAdjacentHTML("afterend", `
      <cart-item id="js-socks-gwp" class="cart-item">
        <div class="flex flex-grow gap-6 w-full border-b w-full mb-4 pb-4">
          <a href="/products/kizik-ankle-socks-white" class="w-[80px] max-w-[80px] min-w-[80px] block relative h-fit rounded-xl overflow-hidden">
            <img id="gwp-socks--image" class="w-full" src="//kizik.com/cdn/shop/products/1_Kizik_Charcoal_Profile_Mock_160x.png?v=1637778072">
          </a>
          <div class="flex-1 relative">
          
            <h5 class="text-left font-bold text-x100" style="padding-top: .5rem;"><span class="text-x100">Claim Your Free <span class="js-gwp--hidden-mobile">Ankle </span>Socks!</span></h5>
            <p class="font-accent text-grey400 text-x80 leading-4 mb-2">
              <span id="js-gwp-color--label">charcoal</span> - <span id="js-gwp-size--label">one-size</span>
            </p>

            <div style="display: flex; justify-content: space-between;">

              <div style="grid-column: span 2; display:none;">
                <div class="gwp-socks--option btn btn-selector btn-selector-size btn-selector-color-swatch" data-color="black">Black</div>
                <div class="gwp-socks--option btn btn-selector btn-selector-size btn-selector-color-swatch js-gwp--active" data-color="white">White</div>              
              </div>

              <div style="grid-column: span 2; text-align: right; display:none;">
                <div class="gwp-socks--option btn btn-selector btn-selector-size js-gwp--active" data-size="medium">Medium</div>
                <div class="gwp-socks--option btn btn-selector btn-selector-size" data-size="large">Large</div>
              </div>

              <a style="padding: 0 15px !important; border-radius: 25px !important; font-weight: 400 !important;" 
              id="gwp-socks--atc" 
              href="https://kizik.com/cart/add?items[][id]=${bfcm_2024_gwp_var_id}&items[][quantity]=1&items[][properties][_promo]=socks&return_to=${window.location.pathname}?cart=open" 
              class="btn btn-selector btn-selector-size js-gwp--atc">Add &rarr;</a>

            </div>
            
          </div>
        </div>
      </cart-item>
      `);
    })

    /*
    // intercept checkout action
    observeSelector('cart-wrapper footer', cart => {
      // if(document.querySelectorAll('.js-cart--checkout-button-mask').length == 0){
      // }
      cart.insertAdjacentHTML("afterbegin", `
        <div class="js-cart--checkout-button-mask"></div>
      `);
    })
    */
  
    let review_cart_contents = () => {

      console.log("review_cart_contents()");

      if(document.querySelectorAll('cart-item:not([data-tags*="Kids"],[data-tags*="Closeout"],[data-tags*="Gift Card"],[data-tags*="Accessory"],[data-tags*="one-size-fits-most"], #js-socks-gwp)').length > 0){
        doc.setAttribute("data-add-promo-item", true);
        if(!window.sessionStorage.getItem("bfcm-item-auto-added-to-cart")){
          add_items_to_cart(
            {
              id: bfcm_2024_gwp_var_id,
              quantity: 1,
              properties: { "_promo": "true" },
            },
            () => {
              window.sessionStorage.setItem("bfcm-item-auto-added-to-cart", true);
              let changeEvent = new Event('change', { bubbles: true });
              document.querySelector('#section--cart-items_quantity').dispatchEvent(changeEvent);
              // window.location.href = `${window.location.pathname}?cart=open`;
            }
          );
        }
        if(document.querySelectorAll('cart-item[data-tags*="one-size-fits-most"]').length > 0){
          doc.removeAttribute("data-add-promo-item");
          doc.setAttribute("data-promo-item-added", true);
        }
      } else {
        doc.removeAttribute("data-add-promo-item");
        doc.removeAttribute("data-promo-item-added");
        
        // if ANY promo item is in the cart remove it so we can add it ONLY via checkout button
        /*
        cart_items_w_line_prop("_promo", "remove").then(() => {
          observeSelector('cart-item[data-props*="promo"]', promo_item => {
            promo_item.remove();
          })
        });
        */
        
      }
    
    } // review_cart_contents()

    // init 
    review_cart_contents();

    /*
    observeSelector('.js-cart--checkout-button-mask', js_checkout => {
      js_checkout.addEventListener("click", () => {
        console.log("js_checkout CLICK");
        cart_items_w_line_prop("_promo", "read").then(response => { 
          console.log(response)
          if(!response){
            add_items_to_cart(
              {
                id: bfcm_2024_gwp_var_id,
                quantity: 1,
                properties: { "_promo": "true" },
              },
              () => {
                window.location.href = "/checkout";
              }
            );
          } else {
            window.location.href = "/checkout";
          }
        });
      });
    });
    */

    observeSelector('cart-item', cart_line_item => {
      review_cart_contents();
    });
  
  }).catch();
  
}

////////////////////////////////////////////
// END BFCM 2024 -- CHARCOAL SOCKS GWP //
//////////////////////////////////////////

// findify patch -- search issue -- inject search form
if(window.location.href.indexOf("/search") > -1){
  waitForElement('#findify-search').then(search_widget => {
    if(document.querySelectorAll('form[action="/search"]').length == 0){
      search_widget.insertAdjacentHTML("beforebegin", `
      <form action="/search" method="get" role="search" class="search">
					<div class="flex flex-grow items-center max-w-[1200px] w-full m-auto relative">
<input id="template--17937600938141__main_search" class="w-full border-0 border-b border-black h1 placeholder:h1" type="search" name="q" placeholder="Search" value="">
<label class="visually-hidden" for="template--17937600938141__main_search">Search</label>

<input type="hidden" name="type" value="product,article">
						<input type="hidden" name="options[prefix]" value="last">
						<button class="hidden md:block underline text-x100 absolute top-1/2 right-0 -translate-y-1/2" type="reset">Clear</button>
						<button class="hidden" type="submit" aria-label="Search">
							<div class="w-10 h-10 flex items-center justify-center">
								<div class="w-[18px] h-[19px]"><svg class="icon icon-search" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M19.9 20.9746L13.325 14.3996C12.825 14.8329 12.2417 15.1704 11.575 15.4121C10.9083 15.6538 10.2 15.7746 9.45 15.7746C7.65 15.7746 6.125 15.1496 4.875 13.8996C3.625 12.6496 3 11.1413 3 9.37461C3 7.60794 3.625 6.09961 4.875 4.84961C6.125 3.59961 7.64167 2.97461 9.425 2.97461C11.1917 2.97461 12.6958 3.59961 13.9375 4.84961C15.1792 6.09961 15.8 7.60794 15.8 9.37461C15.8 10.0913 15.6833 10.7829 15.45 11.4496C15.2167 12.1163 14.8667 12.7413 14.4 13.3246L21 19.8746L19.9 20.9746ZM9.425 14.2746C10.775 14.2746 11.925 13.7954 12.875 12.8371C13.825 11.8788 14.3 10.7246 14.3 9.37461C14.3 8.02461 13.825 6.87044 12.875 5.91211C11.925 4.95378 10.775 4.47461 9.425 4.47461C8.05833 4.47461 6.89583 4.95378 5.9375 5.91211C4.97917 6.87044 4.5 8.02461 4.5 9.37461C4.5 10.7246 4.97917 11.8788 5.9375 12.8371C6.89583 13.7954 8.05833 14.2746 9.425 14.2746Z" fill="currentColor"></path>
</svg>
								</div>
							</div>	
						</button>
</div>
				</form>

    <style>
    .findify-heading{
      display: none !important;
    }
    </style>
      `);
      
    }
  }).catch();
}

/* START SHIPSCOUT */

waitForElement('body').then(doc => {
  doc.insertAdjacentHTML("afterbegin", `
  <style>
    .js-conceal{
      /* opacity: 0 !important; */
      transition: 1s ease all;
    }
    .js-conceal.js-reveal{
      opacity: 1 !important;
    }
  </style>
  `)
}).catch();

// CONCEAL Free Shipping callouts  
if(window.location.href.indexOf("/products/") > -1){

  // PDP
  observeSelector('.product-hero-card span', hero_span => {
    if(hero_span.innerText.indexOf("Free Shipping & Returns") > -1){
      hero_span.classList.add("js-conceal")
    }
  })

  observeSelector('accordion-tab', accordian => {
    if(accordian.innerText.indexOf("Free Shipping") > -1){
      accordian.querySelector('h2').classList.add("js-conceal")
      accordian.querySelector('div > p').classList.add("js-conceal")
    }
  })
  
} // is PDP

observeSelector('cart-wrapper footer b', cart_message => {
  if(cart_message.innerText.indexOf("Free Shipping & No Hassle Returns!") > -1){
    cart_message.classList.add("js-conceal")
  }
});

observeSelector('main h3', subtitle => {
  if(subtitle.innerText.indexOf("Shipping is always free.") > -1){
    subtitle.classList.add("js-conceal")
  }
});

observeSelector('.marquee-text span > p', marquee_text => {
  if(marquee_text.innerText.indexOf("FREE SHIPPING") > -1){
    marquee_text.classList.add("js-conceal")
  }
})

window.ss_variant = "";

const init_shipscout = () => {
  window._shipScout = window._shipScout || [];
  _shipScout.push(function (response) {
    
    console.log(response)
    window.ss_variant = response.variant

    let threshold_cents = 0;
    if(!!response.thresholdCents){
      threshold_cents = response.thresholdCents;
    }
    
    dataLayer.push({
      'event': 'proteus_experiment_pageview',
      'proteus_exp_id': "KIZ-56",
      'proteus_var_id': response.variant,
      'proteus_exp_name': `Free Shipping $${(threshold_cents / 100).toFixed(0)}`,
      'proteus_exp_version': "0.01",
    });

    console.log(`[KIZ-56] Free Shipping $${(threshold_cents / 100).toFixed(0)}`);

    // update and/or reveal Free Shipping callouts  

    if(window.location.href.indexOf("/products/") > -1){
    
      // PDP
      observeSelector('.product-hero-card span', hero_span => {
        if(hero_span.innerText.indexOf("Free Shipping & Returns") > -1){
          if(response.variant == "D"){
            hero_span.innerText = `Free Shipping for Orders of 2+ Pairs`;
          } else if(response.variant != "A" && threshold_cents > 0) {
            hero_span.innerText = `Free Shipping for Orders $${(threshold_cents/100).toFixed(0)}+`; 
          }
          hero_span.classList.add("js-reveal");
        }
      })

      observeSelector('accordion-tab', accordian => {
        if(accordian.innerText.indexOf("Free Shipping") > -1){
          if(response.variant == "D"){
            accordian.querySelector('h2').innerText = `Free Shipping for Orders of 2+ Pairs`;
            accordian.querySelector('div > p').innerText = `All Kizik orders of 2+ pairs ship free within the United States.`;
          } else if(response.variant != "A" && threshold_cents > 0) {
            accordian.querySelector('h2').innerText = `Free Shipping for Orders $${(threshold_cents/100).toFixed(0)}+`; 
            accordian.querySelector('div > p').innerText = `All Kizik orders $${(threshold_cents/100).toFixed(0)}+ ship free within the United States.`; 
          }
          accordian.querySelector('h2').classList.add("js-reveal");
          accordian.querySelector('div > p').classList.add("js-reveal");
        }
      })
      
    } // is PDP

    observeSelector('cart-wrapper footer b', cart_message => {
      if(cart_message.innerText.indexOf("Free Shipping & No Hassle Returns!") > -1){
        if(response.variant == "D"){
          cart_message.innerText = `Free Shipping on 2+ Pairs & No Hassle Returns!`;
        } else if(response.variant != "A" && threshold_cents > 0) {
          cart_message.innerText = `Free Shipping for $${(threshold_cents/100).toFixed(0)}+ & No Hassle Returns!`; 
        }
        cart_message.classList.add("js-reveal");
      }
    });

    observeSelector('main h3', subtitle => {
      if(subtitle.innerText.indexOf("Shipping is always free.") > -1){
        if(response.variant == "D"){
          subtitle.innerText = `Shipping is free with 2+ pairs.`;
        } else if(response.variant != "A" && threshold_cents > 0) {
          subtitle.innerText = `Shipping is free for $${(threshold_cents/100).toFixed(0)}+ orders.`; 
        }
        subtitle.classList.add("js-reveal");
      }
    });

    observeSelector('.marquee-text span > p', marquee_text => {
      if(marquee_text.innerText.indexOf("FREE SHIPPING") > -1){
        if(response.variant == "D"){
          marquee_text.innerText = `FREE SHIPPING FOR 2+ PAIRS`;
        } else if(response.variant != "A" && threshold_cents > 0) {
          marquee_text.innerText = `FREE SHIPPING FOR ORDERS $${(threshold_cents/100).toFixed(0)}+`; 
        }
        marquee_text.classList.add("js-reveal");
      }
    })
    
  
    if(window.sessionStorage.getItem("ss-active") || !!threshold_cents || response.dynamicShipping){
      window.sessionStorage.setItem("ss-active", true);
      let fs_threshold = threshold_cents/100;
      let cart_total = 0;
      // check for cart updates every .5s

      setInterval(() => {
        if(document.querySelectorAll(".js-incentives").length == 0 && document.querySelectorAll("cart-wrapper header").length > 0){
          document.querySelector('cart-wrapper header').insertAdjacentHTML("afterend", `
          <style>
          .js-incentives{
            padding: 1rem;
            margin-top: -4rem;
          }
          
          .js-incentives--message{
            font-size: .85rem;
            text-align: center;
            margin: 0 -1rem .5rem -1rem;
          }
          
          .js-incentives--message strong{
            font-weight: 600;
          }
          
          .js-incentives--bar{
            background: #eee;
            border-radius: 25px;
            height: 6px;
            position: relative;
            margin: .5em;
          }
          
          .js-incentives--bar--filled{
            display: block !important;
            transition: .5s ease width;
            width: 10%;
            background: #0022b5;
            border-radius: 25px;
            height: 6px;
            position: absolute;
            left: 0;
            top: 0;
          }
          
          </style>
          <div class="js-incentives">
            <div class="js-incentives--message">...</div>
            <div class="js-incentives--bar">
              <div class="js-incentives--bar--filled"></div>
            </div>
          </div>
          `);
        }

        if(document.querySelectorAll('cart-wrapper footer button[name="checkout"]').length > 0){
          let current_cart_total = parseFloat(document.querySelector('cart-wrapper footer button[name="checkout"]').innerText.split("$")[1]);
          
          if(cart_total != current_cart_total){
            // update fs bar
            cart_total = current_cart_total;
            let message_text = `You are $${(fs_threshold - cart_total).toFixed(2)} away from FREE SHIPPING`;
            
            if(cart_total < fs_threshold){
              if(response.variant == "D"){
                
                let shoe_count = 0;
                let cart_items = document.querySelectorAll('cart-wrapper cart-item');
                for(let i = 0; i < cart_items.length; i++){
  
                  if(cart_items[i].getAttribute("data-type").indexOf("Insole") == -1 &&
                  cart_items[i].getAttribute("data-type").indexOf("Sock") == -1 &&
                  cart_items[i].getAttribute("data-type").indexOf("Gift Card") == -1 &&
                  cart_items[i].getAttribute("data-type").indexOf("Shoe Care Kit") == -1){
                    shoe_count += parseInt(cart_items[i].getAttribute("data-qty"));
                  }
                  
                  if(i == cart_items.length - 1){
                    if(shoe_count >= 2){
                      document.querySelector('.js-incentives--message').innerHTML = `🎉 Congrats! You've unlocked FREE SHIPPING!`;
                      document.querySelector('.js-incentives--bar--filled').style.width = "100%";
                    } else {
                      message_text = `Add another pair for FREE SHIPPING`;
                      document.querySelector('.js-incentives--message').innerHTML = message_text;
                      document.querySelector('.js-incentives--bar--filled').style.width = `50%`; 
                    }   
                  }
                }
                
              } else {
                document.querySelector('.js-incentives--message').innerHTML = message_text;
                document.querySelector('.js-incentives--bar--filled').style.width = `${(cart_total / fs_threshold) * 100}%`; 
              }
            } else {
              document.querySelector('.js-incentives--message').innerHTML = `🎉 Congrats! You've unlocked FREE SHIPPING!`;
              document.querySelector('.js-incentives--bar--filled').style.width = "100%";
            } 
            console.log("cart updated...", cart_total);
          }
        }
        
      }, 500)
      
    }
  }); // _shipScout.push()  
  
}; // init_shipscout()

document.addEventListener("DOMContentLoaded", init_shipscout);

if(window.ss_variant == ""){
   
}

let ss_init_attempts = 0
const retry_ss_init = setInterval(() => {

  ss_init_attempts ++;
  
  if (window.ss_variant != "" || ss_init_attempts >= 5) {
    clearInterval(retry_ss_init);
    return;
  }

  if(ss_init_attempts >= 2 ){
    observeSelector(".js-conceal:not(.js-reveal)", concealed_element => {
      concealed_element.classList.add('js-reveal');
    })
  }
  
  // console.log(`Trying again to init SS -- ${ss_init_attempts} tries`);
  init_shipscout()
  
}, 5000); 

/* END SHIPSCOUT */

// PDP spotfix -- ATC button broken
if(window.location.href.indexOf("/products/") > -1 && window.location.href.indexOf("spotfix=false") == -1){

  /*
  if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 && navigator.userAgent.indexOf('Chromium') === -1) {
    // no issues on Safari, do nothing
  } else {
    // apply spotfix
  }
  */

  observeSelector('button[name="add"]', atc_btn => {
    atc_btn.addEventListener("click", (e) => {
      console.log("click -- intercept ATC");
      e.preventDefault();

      let var_id = !!getParam('variant') ? getParam('variant') : meta.product.variants[0].id;
      if(atc_btn.closest('form').querySelectorAll('input#add-to-cart-form--id').length > 0){
        var_id = atc_btn.closest('form').querySelector('input#add-to-cart-form--id').value;
      }
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: var_id,
          quantity: 1,
        }),
      }).then(response => response.json()).then(data => {
        console.log('Item added to cart:', data);
        let param_appender = window.location.href.indexOf("?") > -1 ? "&" : "?";
        window.location.href = window.location.href + param_appender + "cart=open";
      })
  
    })
  })  
      
}

if (getParam("exp")) {
  let exp = getParam("exp");
  let exp_var = "v1";
  if (getParam("var")) {
    exp_var = getParam("var");
  }
  window.sessionStorage.setItem(exp, exp_var);
  if (exp == "KZ-01" || exp == "KIZ-01") {
    window.sessionStorage.setItem("KIZ-01" + exp_var, "Submitted");
    window.sessionStorage.setItem("KZ-01" + exp_var, "Submitted");
  }
}

js_loadScript(
  "https://ajax.googleapis.com/ajax/libs/jquery/3.6.4/jquery.min.js"
);

if(getParam("qa") == "BFCM"){
  window.sessionStorage.setItem("progressive-cart--BFCM--QA", true);
}

observeSelector('a[href*="black-friday-promo"]', promo_item_link => {
  promo_item_link.removeAttribute("href");
});

if(window.location.href.indexOf("/products/") > -1 && window.location.href.indexOf("black-friday-promo") > -1){
  window.location.href = "/";
}

waitUntil(() => {
  return window.sessionStorage.getItem("progressive-cart--BFCM") || window.sessionStorage.getItem("progressive-cart--BFCM--QA");
}).then(() => {
  
  /*

  [KIZ-BFCM]
  v1: incentives with threshold -- 0.01

  1 pair: free socks
  2 pair: free cleaning kit
  3+ pair: 15% off

  "add 1 more pair to get ____"
  "add 1 more pair and save up to ____"

  exclude kid shoes + last chance shoes

  NO CODE needed
  reject all other discount codes
  Its Black Friday/Cyber Monday -- You are already getting the best deal!

  */

  waitForElement('body').then(doc => {

    let exp_id = "KIZ-BFCM";
    let exp_var = "v1";
    console.log(`init [${exp_id}] -- 0.01 -- ${exp_var}`);

    observeSelector('cart-item', cart_item => {
      waitUntil(() => {
        return cart_item.querySelectorAll('[data-price]').length > 0;
      }).then(() => {
        let full_price = parseInt(cart_item.querySelector('[data-price]').getAttribute("data-full-price"));
        let line_price = parseInt(cart_item.querySelector('[data-price]').getAttribute("data-price")); 
        if(full_price > line_price){
          cart_item.querySelector('[data-price]').insertAdjacentHTML("afterbegin", `
            <s style="opacity: .35; padding-right: 0.5rem;">$${(full_price / 100).toFixed(2)}</s>
          `);
        }
      }).catch();
    })

    // set checkout action
    window.js_checkout_href = "/checkout";

    // v1 goals
    const incentives_goals = [
      {
        threshold: 1,
        message: "FREE SOCKS",
        label: "3-pack of socks<br>($30 value)",
        prompt: "BUY 1 PAIR",
        var_id: "none"
      },
      {
        threshold: 2,
        message: "CLEANING KIT",
        label: "free cleaning kit<br>($25 value)",
        prompt: "BUY 2 PAIRS",
        var_id: "none",
      },
      {
        threshold: 3,
        message: "15% OFF",
        label: `15% off<br>(<span id="js-15off-total">$40+</span> saved)`,
        prompt: "BUY 3 PAIRS",
        var_id: "none",
      }
    ];

    const checkmark_svg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="800px" width="800px" version="1.1" id="Capa_1" viewBox="0 0 17.837 17.837" xml:space="preserve">
    <g>
      <path d="M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27   c-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0   L17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z"/>
    </g>
    </svg>`;

    // inject treatment styles
    doc.insertAdjacentHTML("afterbegin", `
      <style>
        cart-wrapper header{
          padding-bottom: 0 !important;
          height: auto !important;
        }

        .js-hidden,
        #slidecarthq .slidecarthq > .rewards{
          display: none; 
          opacity: 0;
          position: absolute;
          left: -9999px;
        }

        .js-free span.price{
          font-size: 0 !important;
        }

        .js-free span.price:after{
          content: "FREE";
          font-size: 16px;
          font-weight: 600;
          color: #36f;
        }

        /* --- START INCENTIVES MODULE --- */

          .js-incentives{
            background: #36f;
            color: #fff;
            padding: 18px 30px;
            margin-bottom: 2rem;
            position: relative;
          }

          .js-incentives--disclaimer{
            position: absolute;
            bottom: -1.5em;
            left: 0;
            color: #000;
            font-size: .7em;
          }

          .js-incentives-mesage{
            font-size: 15px;
            text-align: center;
            margin-bottom: 2.5rem;
          }

          .js-incentives-mesage strong{
            font-weight: 600;
          }

          .js-incentives--bar{
            background: #7596ff;
            border-radius: 25px;
            height: 6px;
            position: relative;
            margin-bottom: 2rem;
          }

          .js-incentives--bar--filled{
            transition: .5s ease width;
            width: 10%;
            background: #fff;
            border-radius: 25px;
            height: 6px;
            position: absolute;
            left: 0;
            top: 0;
          }

          .js-incentives--goals{

          }

          .js-incentives--threshold{
            position: absolute;
            top: 0;
          }

          .js-incentives--threshold--dot{
            width: 18px;
            height: 18px;
            border-radius: 100%;
            background: #7596ff;
            position: absolute;
            top: -6px;
            left: -18px;
          }

          .js-incentives--threshold.js-threshold-met .js-incentives--threshold--dot{
            background: #fff;
          }

          .js-incentives--threshold--dot--icon{
            transition: .5s ease opacity;
            opacity: 0;
            padding: 3px;
          }

          .js-incentives--threshold.js-threshold-met .js-incentives--threshold--dot--icon{
            opacity: 1;
          }

          .js-incentives--threshold--dot--icon svg{
            width: 100%; 
            height: auto;
            fill: #36f !important;
          }

          .js-incentives--threshold--label,
          .js-incentives--threshold--prompt{
            transition: .5s ease opacity;
            position: absolute;
            font-size: 11px;
            top: 16px;
            right: -30px;
            width: 78px;
            white-space: nowrap;
            text-align: center;
          }

          .js-incentives--threshold--prompt{
            top: -30px;
          }

          .js-incentives--threshold.js-reveal .js-incentives--threshold--label,
          .js-incentives--threshold.js-tease .js-incentives--threshold--label{
            opacity: 1;
          }

          [data-hide-socks="true"] cart-item#js-socks-gwp{
            display:none !important;
          }

      </style>
    `);

    observeSelector('cart-wrapper button[name="checkout"]', checkout_btn => {
      setTimeout(() => {

        if(window.sessionStorage.getItem("show-gwp-socks--BFCM") && !window.sessionStorage.getItem("gwp-added")){
          checkout_btn.addEventListener("click", (e) => {
            e.preventDefault();
            cart_add_item(44190216192157, 1, () => {
              window.location.href = "/checkout"
            });
          });
        }

      }, 1500); 
    });

    observeSelector('cart-wrapper', cart_wrapper => {

      setTimeout(() => {

        // auto open cart
        /*
        if(getParam("cart") == "open"){
          waitForElement('.site-header__icon.site-header__cart').then(el => {
            el.click();
          }).catch();
        }
        */

        let thresholds_html = "";
        // set max to largest threshold's setting (which is expected to be the last item of the array)
        let incentives_max = incentives_goals[incentives_goals.length -1].threshold;

        for(let i = 0; i < incentives_goals.length; i++){
          let range_position = (incentives_goals[i].threshold / incentives_max) * 100 - (15/incentives_goals[i].threshold);
          thresholds_html = thresholds_html + `
            <div class="js-incentives--threshold" data-threshold="${incentives_goals[i].threshold}" data-var-id="${incentives_goals[i].var_id}" data-discount-code="${incentives_goals[i].discount}" style="left: ${range_position}%;" data-label="${incentives_goals[i].message}">
              <div class="js-incentives--threshold--dot">
                <div class="js-incentives--threshold--dot--icon">${checkmark_svg}</div>
              </div>
              <div class="js-incentives--threshold--prompt">${incentives_goals[i].prompt}</div>
              <div class="js-incentives--threshold--label">${incentives_goals[i].label}</div>
            </div>
          `;
        }

        cart_wrapper.querySelector('header').insertAdjacentHTML("afterend", `
          <div class="js-incentives">
            <div class="js-incentives-mesage"></div>
            <div class="js-incentives--bar">
              <div class="js-incentives--bar--filled"></div>
              <div class="js-incentives--goals">
                ${thresholds_html}
              </div>
            </div>
            <div class="js-incentives--disclaimer">*Excludes kids shoes</div>
          </div>
        `);

        const update_incentives_module = (number_of_items) => {

          let incentives_message = document.querySelector('.js-incentives-mesage')
          let incentives_bar_filled = document.querySelector('.js-incentives--bar--filled')
          let incentives_message_set = false;
          let earned_incentives = [];

          if(number_of_items >= incentives_max){
            
            incentives_bar_filled.style.width = "100%";
            waitForElement('cart-wrapper button[name="checkout"]').then(checkout_btn => {
              let order_savings = (parseInt(checkout_btn.getAttribute("data-total-savings")) * 0.01).toFixed(2);
              incentives_message.innerHTML = `<strong>Heel yeah!</strong> Free stuff and you're saving $${order_savings}`;
              document.querySelector('#js-15off-total').innerHTML = `$${(order_savings - 55.00).toFixed(2)}`;
            }).catch();
            
          } else {
            incentives_bar_filled.style.width = `${(number_of_items / incentives_max) * 100 - (15 / number_of_items)}%`;
          }

          let incentives_thresholds = document.querySelectorAll('.js-incentives--threshold');
          incentives_thresholds[0].classList.add('js-tease');
          for(let i = 0; i < incentives_thresholds.length; i++){

            let incentives_message_html = ""; 

            let threshold_amount = parseInt(incentives_thresholds[i].getAttribute("data-threshold"));
            let threshold_label = incentives_thresholds[i].getAttribute("data-label");
            let threshold_var_id = incentives_thresholds[i].getAttribute("data-var-id");
            let threshold_discount = incentives_thresholds[i].getAttribute("data-discount-code");

            if(number_of_items >= threshold_amount){
              incentives_thresholds[i].classList.add('js-threshold-met');
              incentives_thresholds[i].classList.add('js-reveal');
              
              // tesase the next
              if(i+1 < incentives_thresholds.length){
                incentives_thresholds[i+1].classList.add('js-tease');
              }
              if(threshold_var_id != "none"){
                earned_incentives.push(threshold_var_id);
              } else if(threshold_discount != ""){
                window.js_checkout_href = `/checkout?discount=${threshold_discount}`;
              }
            } else {
              incentives_thresholds[i].classList.remove('js-threshold-met');
              incentives_thresholds[i].classList.remove('js-reveal');
              // un-tesase the next
              if(i+1 < incentives_thresholds.length){
                incentives_thresholds[i+1].classList.remove('js-tease');
              }
            }

            // assess free stuff in cart
            window.kit_in_cart = false;
            window.socks_in_cart = false;
            for(let i = 0; i < Zero.Cart.items.length; i++){
              if(Zero.Cart.items[i].variant_id == 44190217175197){
                window.kit_in_cart = true;
              }
              if(Zero.Cart.items[i].variant_id == 44190216192157 || 
                Zero.Cart.items[i].variant_id == 44190210556061 || 
                Zero.Cart.items[i].variant_id == 44190216224925 || 
                Zero.Cart.items[i].variant_id == 44190210588829 ||
                Zero.Cart.items[i].variant_id == 37193031483549){
                window.socks_in_cart = true;
              }
            }

            const hide_socks_atc = () => {
              console.log("hide_socks_atc()");
              window.sessionStorage.removeItem("show-gwp-socks--BFCM")
              window.sessionStorage.setItem("gwp-added", true);
              document.documentElement.setAttribute("data-hide-socks", true);
              waitForElement('cart-item#js-socks-gwp').then(el => {
                el.remove();
              }).catch();
            };

            const show_socks_atc = () => {
              console.log("show_socks_atc()");
              window.sessionStorage.setItem("show-gwp-socks--BFCM", true)
              window.sessionStorage.removeItem("gwp-added");
              document.documentElement.setAttribute("data-hide-socks", false);
            };

            if(!incentives_message_set){
              if(number_of_items < threshold_amount){
                
                if(number_of_items == 0){

                  incentives_message_html = `Add a pair of shoes and get <strong>FREE SOCKS</strong>`;
                  hide_socks_atc();

                } else if(number_of_items == 1){

                  // document.querySelector('#js-15off-total').innerHTML = `$${((Zero.Cart.stats.total * 3) * 0.0015).toFixed(2)}`;
                  
                  incentives_message_html = `Add another pair of shoes and get a <strong>FREE CLEANING KIT</strong>`;
                  // show socks if not already in cart
                  !window.socks_in_cart ? show_socks_atc() : hide_socks_atc();

                } else if(number_of_items > 1){
                  incentives_message_html = `Add one more pair and get 
                  <strong>15% OFF</strong><br>(that's up to $${((Zero.Cart.stats.total + 15000) * 0.0015).toFixed(2)})`;

                  // show socks if not already in cart
                  !window.socks_in_cart ? show_socks_atc() : hide_socks_atc();

                  // add kit if not already in cart
                  if(!window.kit_in_cart){
                    cart_add_item(44190217175197, 1, () => {
                      // spoof a change to reload cart
                      let changeEvent = new Event('change', { bubbles: true });
                      document.querySelector('#section--cart-items_quantity').dispatchEvent(changeEvent);
                    });
                  }

                } 

                incentives_message.innerHTML = incentives_message_html;
                incentives_message_set = true;
              }
            }

          }

        }

        const compare_totals = () => {
          
          let bfcm_qualifying_item_count = 0;

          for(let i = 0; i < Zero.Cart.items.length; i++){
            if(window.bfcm_handle_list.indexOf(Zero.Cart.items[i].handle) == -1){
              bfcm_qualifying_item_count += Zero.Cart.items[i].quantity;
            }

            if(i == Zero.Cart.items.length - 1){
              document.documentElement.setAttribute("data-bfcm-qualifying-items", bfcm_qualifying_item_count);
              update_incentives_module(bfcm_qualifying_item_count)

            }
          }

        };

        // init
        setTimeout(() => {
          compare_totals();
        }, 1500)

        Object.defineProperty(Zero.Cart.stats, 'count', {

          get() {
              return this._count;
          },
          set(value) {
            setTimeout(() => {
              this._count = value;
              compare_totals();
            }, 50);
          }
        });

      }, 50);

    });

  }).catch();
  /* END BFCM */
}).catch();

waitUntil(() => {
  return typeof Zero !== "undefined" &&
         typeof Zero.Cart !== "undefined" &&
         window.sessionStorage.getItem("KIZ-Holiday-Gift-Cards");
}).then(() => {

  console.log("INIT GIFT CARDS")

  observeSelector('#cart-drawer cart-wrapper', cart => {
    if(Zero.Currency.locale == "USD"){

      let checkout_btn = cart.querySelector('button[name="checkout"]');

      if(document.querySelectorAll('.js-cart-message--gift-card').length == 0){

        document.querySelector('#cart-drawer cart-wrapper header').insertAdjacentHTML("afterend", `
        <style>
          [class*="js-cart-message--text"],
          .js-cart-message--gift-card{
            display: flex;
            text-align: center;
          }

          .js-cart-message--gift-card{
              background: #36f;
              margin: -3rem -1.5rem 1.5rem -1.5rem;
              padding: 0.5rem 1.5rem;
              color: #fff;
              position: relative;
              justify-content: center;
              align-items: center;
              font-size: 14px;
          }

          @media(max-width: 430px){
            .js-cart-message--gift-card{
                padding: 0.5rem;
                font-size: 12px;
            }
          }

          .js-cart-message--gift-card strong{
            font-weight: 700;
          }

          .js-cart-message--image{
            width: 40px;
            margin-right: .75rem;
          }
          .js-cart-message--image img{
            border-radius: .75rem;
          }
          
          
        </style>
        <div class="js-cart-message--gift-card">
          <div class="js-cart-message--image">
            <img src="//kizik.com/cdn/shop/products/Kizik_Gift_Card_Sleve.png?v=1666985787" />
          </div>
          <div class="js-cart-message--text">
            <div>You're just $150 away from a <strong>FREE $20 Gift Card!</strong></div>
          </div>
        </div>
      `);
        

      }
      
      checkout_btn.addEventListener("click", (e) => {
        e.preventDefault();
        if(document.documentElement.getAttribute("data-gwp-item") != "NONE"){
          for(let i = 0; i < Zero.Cart.items.length; i++){
            if(Zero.Cart.items[i].variant_id == document.documentElement.getAttribute("data-gwp-item")){
              window.location.href = "/checkout";
              break;
            }
            if(i == Zero.Cart.items.length - 1){
              window.location.href = `/cart/add/?id=${document.documentElement.getAttribute("data-gwp-item")}&quantity=1&return_to=/checkout`;
            }
          }
        } else {
          window.location.href = "/checkout";
        }
      });
    }
  });

  let changeEvent = new Event('change', { bubbles: true });

  // observe and review cart contents
  Object.defineProperty(Zero.Cart.stats, 'count', {
    get() {
        return this._count;
    },
    set(value) {
      setTimeout(() => {
        this._count = value;
  
        window.socks_in_cart = false;
        for(let i = 0; i < Zero.Cart.items.length; i++){
          if(Zero.Cart.items[i].variant_id == 43847775551645 || 
            Zero.Cart.items[i].variant_id == 43847774240925 || 
            Zero.Cart.items[i].variant_id == 43847775617181 || 
            Zero.Cart.items[i].variant_id == 43847774306461 || 
            Zero.Cart.items[i].variant_id == 37193031483549){
            window.socks_in_cart = true;
          }

        }

        if(Zero.Cart.stats.subtotal < 15000){
          // below first threshold
          document.querySelector('.js-cart-message--text').innerHTML = `
            <div>You're just $${(15000 - Zero.Cart.stats.subtotal)/100} away from a <strong>FREE $20 Gift Card!</strong></div>
          `;
          document.documentElement.setAttribute("data-gwp-item", "NONE");
        } else if(Zero.Cart.stats.subtotal >= 15000 && Zero.Cart.stats.subtotal < 25000){
          // $20 Gift Card
          document.querySelector('.js-cart-message--text').innerHTML = `
            <div>
              <strong>UNLOCKED!</strong> $20 Gift Card When You Spend $150<br>
              <small>Spend $${(25000 - Zero.Cart.stats.subtotal)/100} more and unlock a $40 Gift Card</small>
            </div>
          `;
          document.documentElement.setAttribute("data-gwp-item", "44250608926877");
        } else if(Zero.Cart.stats.subtotal >= 25000 && Zero.Cart.stats.subtotal < 35000){
          // $40 Gift Card
          document.querySelector('.js-cart-message--text').innerHTML = `
            <div>
              <strong>UNLOCKED!</strong> $40 Gift Card When You Spend $250<br>
              <small>Spend $${(35000 - Zero.Cart.stats.subtotal)/100} more and unlock a $75 Gift Card</small>
            </div>
          `;
          document.documentElement.setAttribute("data-gwp-item", "41341947740317");
        } else if(Zero.Cart.stats.subtotal >= 35000){
          // $75 Gift Card
          document.querySelector('.js-cart-message--text').innerHTML = `
            <div>
              <strong>UNLOCKED!</strong> $75 Gift Card When You Spend $350
            </div>
          `;
          document.documentElement.setAttribute("data-gwp-item", "40928258490525");
        } else {
          document.documentElement.setAttribute("data-gwp-item", "NONE");
        }
        
        if(window.socks_in_cart){
          // socks in cart
          console.log("hide_socks_atc()");
          window.sessionStorage.setItem("gwp-added", true);
          document.documentElement.setAttribute("data-hide-socks", true);
          waitForElement('cart-item#js-socks-gwp').then(el => {
            el.remove();
          }).catch();
        } else {
          console.log("show_socks_atc()");
          window.sessionStorage.removeItem("gwp-added");
          document.documentElement.setAttribute("data-hide-socks", false); 
        }
        
      }, 50);
    }
  });
  
}).catch();

if(getParam("qa") == "holiday-gift-cards"){
  window.sessionStorage.setItem("KIZ-Holiday-Gift-Cards", true);
}

/*START GWP Socks*/
if(getParam("utm_source").indexOf("GWP") > -1 || getParam("exp").indexOf("KIZ-01") > -1 ){
  window.sessionStorage.setItem("show-gwp-socks", true);
  if(getParam("exp").indexOf("KIZ-01") > -1){
    window.sessionStorage.setItem("show-gwp-socks--force-auth", true);
  }
}

if(getParam("qa") == "socks-popup-submission" ||
  getParam("form-submit") ||
  getParam("form-submitted") ||
  getParam("form-signup") ||
  (getParam("exp") == "KIZ-01" && getParam("var") == "v4")){
  window.sessionStorage.setItem("KZ-01v4", "Submitted");
  console.log("proteus !!!!")
}

if(getParam("form-submit").indexOf("sms-") > -1){
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'custom_GA4_event',
    'event_name': "GWP Acquisition -- PostScript",
    'event_description': "via ?form-submit=sms-..."
  });
}

waitUntil(() => {
  return window.sessionStorage.getItem("JustUno Popup") == "Submitted";
}).then(() => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'custom_GA4_event',
    'event_name': "GWP Acquisition -- JustUno",
    'event_description': "via popup form submision"
  });
}).catch();



waitForElement('[id="contact_form"]').then(contact_form => {
  contact_form.addEventListener("submit", () => {
    window.sessionStorage.setItem("KZ-01v4", "Submitted");
  });
}).catch();

waitUntil(() => {
  return typeof window._learnq != "undefined" && 
    (window.sessionStorage.getItem("show-gwp-socks") || 
     window.sessionStorage.getItem("show-gwp-socks--BFCM") || 
     window.sessionStorage.getItem("KZ-01v4") == "Submitted");
}).then(() => {

  let exp_id = "KIZ-GWP";
  let exp_var = "socks";
  console.log(`init [${exp_id}] -- 0.08 -- ${exp_var}`);

  // wait for _learnq to catch up
  waitUntil(() => {
    return typeof window._learnq.isIdentified != "undefined";
  }).then(() => {

    let is_authorized = false;
    if(window._learnq.isIdentified() || window.sessionStorage.getItem("show-gwp-socks--force-auth") || window.sessionStorage.getItem("show-gwp-socks--BFCM") || window.sessionStorage.getItem("KZ-01v4") == "Submitted"){
      is_authorized = true;
    }

    if(!window.sessionStorage.getItem("gwp-added") && is_authorized){

      document.documentElement.setAttribute("data-hide-socks", false);

      let gwp_socks = {
        medium: {
          white: 43847775551645,
          black: 43847774240925
        }, 
        large: {
          white: 43847775617181,
          black: 43847774306461
        },
        one_size: {
          charcoal: 37193031483549
        }
      }

      if(window.sessionStorage.getItem("show-gwp-socks--BFCM")){
        gwp_socks = {
          medium: {
            white: 44190216192157,
            black: 44190210556061
          }, 
          large: {
            white: 44190216224925,
            black: 44190210588829
          }
        }
      }
  
      waitUntil(() => {
        return document.querySelectorAll('cart-wrapper cart-item').length > 0;
      }).then(() => {
  
        let active_color = "charcoal";
        let active_size = "one_size";

        let li_prop = "email_gwp";
        if(window.sessionStorage.getItem("show-gwp-socks--BFCM")){
          li_prop = "BFCM";
        }

        observeSelector("cart-wrapper", () => {
          if(document.querySelectorAll('#js-socks-gwp').length == 0){

            let cart_header = document.querySelector('cart-wrapper cart-item');
            cart_header.insertAdjacentHTML("beforebegin", `
  
            <style>
              .gwp-socks--option{
                opacity: .5;
                font-size: 12px !important;
                width: 4rem;
              }
    
              .gwp-socks--option:first-child{
                margin-right: .25rem;
              }
      
              .gwp-socks--option:hover,
              .gwp-socks--option:not(a):hover{
                opacity: 1;
                background: #f1f1f1;
                border-color: #f1f1f1;
                color: #1b1b1c;
                font-size: .875rem;
                font-weight: 400;
              }
      
              .js-gwp--active,
              .gwp-socks--option.js-gwp--active:hover{
                opacity: 1 !important;
                background: #000;
                border-color: #000;
                color: #fff;
                font-weight: 700;
              }
      
              .js-gwp--atc{
                background: #36f;
                color: #fff;
                grid-column: span 2;
                grid-row: span 2;
                position: absolute;
                top: 0;
                right: 0;
                width: 75px;
              }

              @media(max-width: 768px){
                .js-gwp--hidden-mobile{
                  display: none;
                }
              }
    
              .btn-selector-color-swatch{
                font-size: 0 !important;
                width: 2rem !important;
                height: 2rem !important;
                border-radius: 100%;
                border: 1px solid #000 !important;
                position: relative;
                grid-column: span 3;
                transform: scale(.9);
                opacity: 1 !important;
              }
    
              .btn-selector-color-swatch.js-gwp--active,
              .btn-selector-color-swatch.js-gwp--active:hover{
                transform: scale(1.1);
              }
    
              .btn-selector-color-swatch[data-color="white"] {
                background: #fff !important;
              }
    
              .btn-selector-color-swatch[data-color="black"] {
                background: #000 !important;
              }

              [data-hide-socks="true"] cart-item#js-socks-gwp{
                display:none !important;
              }
    
            </style>
      
            <cart-item id="js-socks-gwp" class="cart-item">
              <div class="flex flex-grow gap-6 w-full border-b w-full mb-4 pb-4">
                <a href="/products/kizik-ankle-socks-white" class="w-[80px] max-w-[80px] min-w-[80px] block relative h-fit rounded-xl overflow-hidden">
                  <img id="gwp-socks--image" class="w-full" src="//kizik.com/cdn/shop/products/1_Kizik_Charcoal_Profile_Mock_160x.png?v=1637778072">
                </a>
                <div class="flex-1 relative">
                
                  <h5 class="text-left font-bold text-x100" style="padding-top: .5rem;"><span class="text-x100">Claim Your Free <span class="js-gwp--hidden-mobile">Ankle </span>Socks!</span></h5>
                  <p class="font-accent text-grey400 text-x80 leading-4 mb-2">
                    <span id="js-gwp-color--label">charcoal</span> - <span id="js-gwp-size--label">one-size</span>
                  </p>
      
                  <div style="display: flex; justify-content: space-between;">
      
                    <div style="grid-column: span 2; display:none;">
                      <div class="gwp-socks--option btn btn-selector btn-selector-size btn-selector-color-swatch" data-color="black">Black</div>
                      <div class="gwp-socks--option btn btn-selector btn-selector-size btn-selector-color-swatch js-gwp--active" data-color="white">White</div>              
                    </div>
    
                    <div style="grid-column: span 2; text-align: right; display:none;">
                      <div class="gwp-socks--option btn btn-selector btn-selector-size js-gwp--active" data-size="medium">Medium</div>
                      <div class="gwp-socks--option btn btn-selector btn-selector-size" data-size="large">Large</div>
                    </div>
      
                    <a id="gwp-socks--atc" class="btn btn-selector btn-selector-size js-gwp--atc">Add &rarr;</a>

                    <!--
                    <a id="gwp-socks--atc" href="https://kizik.com/cart/add?items[][id]=${gwp_socks[active_size][active_color]}&items[][quantity]=1&items[][properties][${li_prop}]=socks&return_to=${window.location.pathname}?cart=open" class="btn btn-selector btn-selector-size js-gwp--atc">Add &rarr;</a>
                    -->
      
                  </div>
                  
                </div>
              </div>
            </cart-item>
            `);
      
            let gwp_options = document.querySelectorAll('.gwp-socks--option');
            for(let i = 0; i < gwp_options.length; i++){
              gwp_options[i].addEventListener("click", (e) => {
      
                if(e.target.getAttribute("data-color")){
                  active_color = e.target.getAttribute("data-color");
                  document.querySelector('#js-gwp-color--label').innerText = active_color;
                  e.target.classList.add("js-gwp--active");
                  document.querySelector(`.gwp-socks--option[data-color]:not([data-color="${active_color}"])`).classList.remove('js-gwp--active');
                  if(active_color == "white"){
                    document.querySelector("#gwp-socks--image").src = "//kizik.com/cdn/shop/files/Socks_Ankle_White_PKG_160x.png?v=1692655899";
                  } else {
                    document.querySelector("#gwp-socks--image").src = "//kizik.com/cdn/shop/files/Socks_Ankle_Black_PKG_160x.png?v=1692655988";
                  }
                }
      
                if(e.target.getAttribute("data-size")){
                  active_size = e.target.getAttribute("data-size");
                  document.querySelector('#js-gwp-size--label').innerText = active_size;
                  e.target.classList.add("js-gwp--active");
                  document.querySelector(`.gwp-socks--option[data-size]:not([data-size="${active_size}"])`).classList.remove('js-gwp--active');
                }
    
                // document.querySelector("#gwp-socks--atc").href = `https://kizik.com/cart/add?items[][id]=${gwp_socks[active_size][active_color]}&items[][quantity]=1&items[][properties][${li_prop}]=socks&return_to=${window.location.pathname}?cart=open`;
                
                
              });  
            }
      
            document.querySelector('#gwp-socks--atc').addEventListener("click", () => {
              window.sessionStorage.setItem("gwp-added", true);
              document.documentElement.setAttribute("data-hide-socks", true);
              waitForElement('cart-item#js-socks-gwp').then(el => {
                el.remove();
              }).catch();
              cart_add_item(gwp_socks[active_size][active_color], 1, () => {
                // spoof a change to reload cart
                let changeEvent = new Event('change', { bubbles: true });
                document.querySelector('#section--cart-items_quantity').dispatchEvent(changeEvent);
              }, {email_gwp: "free socks"});
            });
            
          }
        });
          
      }).catch();
  
    }

  }).catch(); // wait for learnq
  
}).catch();
/* END GWP Socks*/

waitForElement("body")
  .then((doc) => {
    doc.insertAdjacentHTML(
      "afterbegin",
      `
    <style>
      .js-hidden{
        display: none;
        position: absolute;
        left: -9999px;
        opacity: 0;
      }

    </style>
  `
    );

    if (getParam("cart") == "open") {
      waitUntil(() => {
        return (
          typeof $ != "undefined" &&
          document.querySelectorAll("#cart-trigger").length > 0
        );
      })
        .then(() => {
          setTimeout(() => {
            document.querySelector("#cart-trigger").click();
          }, 200);
        })
        .catch();
    }
  })
  .catch();

/* START KZ-01 */

setTimeout(() => {
  waitUntil(() => {
    return document.querySelectorAll("#smile-ui-container iframe").length > 0;
  })
    .then(() => {
      // HIDE bonus earning methods from the Smile widget
      let iframe_head = $("#smile-ui-container iframe").contents().find("head");
      let iframe_css = `
    <style>
      .card-list-item-container [aria-label*="bonus points"]{
        padding: 0;
        margin: 0px 0;
        height: 0;
        overflow: hidden;
      }
      .card-list-item-container:after{
        content: none;
      }
    </style>`;
      $(iframe_head).append(iframe_css);
    })
    .catch();

  waitUntil(() => {
    return (
      typeof Smile != "undefined" &&
      !!Smile.customer &&
      !!getCookie("KZ-01v2--order-total") &&
      !getCookie("KZ-01v2--smile-bonus-applied")
    );
  })
    .then(() => {
      let order_total = getCookie("KZ-01v2--order-total");
      let smile_bonus_id, smile_bonus_points;

      console.log("process bonus", order_total);

      if (order_total > 40000) {
        smile_bonus_points = 500;
        smile_bonus_id = "activity_r829KatG6HlLVSVwz10Nv9d2";
      } else if (order_total > 30000) {
        smile_bonus_points = 400;
        smile_bonus_id = "activity_Dk3rf4zfKP31A4bK8wAR81oJ";
      } else if (order_total > 25000) {
        smile_bonus_points = 300;
        smile_bonus_id = "activity_47PVWmpLgpT9a29Jh3S2q1Yr";
      } else if (order_total > 20000) {
        smile_bonus_points = 250;
        smile_bonus_id = "activity_e2yxD2DU4Jx5rXkU823QjUn4";
      } else if (order_total > 18000) {
        smile_bonus_points = 200;
        smile_bonus_id = "activity_Uc8Gq7Ck2c3yiXLqaJ1076ZZ";
      } else if (order_total > 16000) {
        smile_bonus_points = 180;
        smile_bonus_id = "activity_1ODYz0a61q2v8W1FvHouA9cE";
      } else if (order_total > 14000) {
        smile_bonus_points = 160;
        smile_bonus_id = "activity_JuqR4Uv3VErz9iEG66p4R20k";
      } else if (order_total > 12000) {
        smile_bonus_points = 140;
        smile_bonus_id = "activity_dL31X5e4M6inrBg2Q0DWYq1x";
      } else if (order_total > 10000) {
        smile_bonus_points = 120;
        smile_bonus_id = "activity_8a8c00w8RUW8RgxN8bMzpL4P";
      } else if (order_total > 9000) {
        smile_bonus_points = 100;
        smile_bonus_id = "activity_KnYl9zyK4jJ60RHlJ9y9a76A";
      } else if (order_total > 8000) {
        smile_bonus_points = 90;
        smile_bonus_id = "activity_beoB57YE9mG0p57W96OLvGfe";
      } else if (order_total > 7000) {
        smile_bonus_points = 80;
        smile_bonus_id = "activity_0O7gs4YS736V7yMxffpv9VKW";
      } else {
        smile_bonus_points = 70;
        smile_bonus_id = "activity_SnSSkc04UhC7h9t34Oc2GU4m";
      }

      Smile.createActivity({ token: smile_bonus_id })
        .then(function (activity) {
          // Success
          console.log(
            `${smile_bonus_points} Bonus Kizik Points via Smile.io for a $${(
              order_total * 0.01
            ).toFixed(2)} purchase`,
            activity.id
          );
          setCookie("KZ-01v2--smile-bonus-applied", true, 365);

          waitForElement("a.logo")
            .then((logo) => {
              logo.insertAdjacentHTML(
                "afterbegin",
                `
          <style>
            .js-smile-message{
              transition: .5s ease all;
              pointer-events: none;
              position: absolute;
              opacity: 0;
              top: 1rem;
              left: -100%;
              width: 300%;
              text-align: center;
              background: #3367FF;
              border-radius: 0.375rem;
              color: #fff;
              padding: 1rem;
              font-size: 16px;
              line-height: 1.5em;
            }
            .js-smile-message strong{
              font-size: 20px;
              line-height: 2em;
            }
            .js-smile-message.active{
              opacity: 1;
              top: 3rem;
            }
          </style>
          <div class="js-smile-message">
            <strong>${smile_bonus_points} Bonus Kizik Points!</strong><br>
            You earned this with your recent $${(order_total * 0.01).toFixed(
              2
            )} purchase.
          </div>
        `
              );
              waitForElement(".js-smile-message")
                .then((message) => {
                  setTimeout(() => {
                    message.classList.add("active");
                    setTimeout(() => {
                      message.classList.remove("active");
                      setTimeout(() => {
                        message.remove();
                      }, 2000);
                    }, 6000);
                  }, 1000);
                })
                .catch();
            })
            .catch();
        })
        .catch(function (err) {
          // Failure
          console.log("Something went wrong");
        });
    })
    .catch();
}, 2000);

observeSelector('[href*="/products/"][href*="-promo"]', (el) => {
  el.classList.add("js-hidden");
  if (!!el.closest("cart-item")) {
    el.closest("cart-item").classList.add("js-promo-item");
    el.insertAdjacentHTML(
      "beforebegin",
      `
      <style>
        cart-item.js-promo-item > div {
          padding-top:10px;
        } 
        cart-item.js-promo-item [data-price]{
          position: relative;
        } 
         cart-item.js-promo-item [data-price]:after{
          content: "One Free with Purchase";
          font-family: Pitch Sans,Courier New,monospace;
          color: #838383;
          font-size: 11px;
          text-align: right;
          position: absolute;
          bottom: 20px;
          right: 0;
          width: 190px;
        } 
        cart-item.js-promo-item a[href*="?variant"]{
          display: none;
        } 
      </style>
    `
    );
  }
});

observeSelector('[onclick*="-promo"]', (el) => {
  el.classList.add("js-hidden");
});

observeSelector("cart-item .js-hidden", (el) => {
  el.classList.remove("js-hidden");
});

/* START KZ-05 */
/*accordion-filter-tab:nth-of-type(5), 
accordion-filter-tab:nth-of-type(6) {
    display: none!important;
}*/
/* END KZ-05 */

/*

[KIZ-11] Color Ordering and Defaults
v1: neutral
v2: non-neutral
v3: wild

*/

if (getParam("qa")) {
  let variation = "v1";
  if (getParam("var")) {
    variation = getParam("var");
  }
  window.sessionStorage.setItem(getParam("qa"), variation);
}

waitUntil(() => {
  return window.sessionStorage.getItem("KIZ-11");
})
  .then(() => {
    let exp_id = "KIZ-11";
    let exp_var = window.sessionStorage.getItem("KIZ-11");
    console.log(`init [${exp_id}] -- 0.07 -- ${exp_var}`);

    waitForElement("body")
      .then((doc) => {
        doc.setAttribute("kiz-11", exp_var);
      })
      .catch();

    // redirect BARE (non-filtered) to the necessary view
    if (
      window.location.href.indexOf("/collections/mens-shoes") > -1 ||
      window.location.href.indexOf("/collections/womens-shoes") > -1
    ) {
      if (
        window.location.href.indexOf("?") == -1 ||
        window.location.href.indexOf("?=proteus") > -1
      ) {
        window.location = window.location.pathname + `?view=kiz-11-${exp_var}`;
      }
    } else if (window.location.href.indexOf("/collections/shop-all") > -1) {
      if (
        window.location.href.indexOf("?") == -1 ||
        window.location.href.indexOf("?=proteus") > -1
      ) {
        window.location =
          window.location.pathname + `?view=kiz-11-${exp_var}-shopall`;
      }
    }

    // rewrite BARE (non-filtered) collection links to reduce the need for ^^ this redirect
    let exp_url_param = `view=kiz-11-${exp_var}`;
    const shopAllItems = document.querySelectorAll(
      '[href*="/collections/shop-all"]'
    );
    const collectionMenuItems = document.querySelectorAll(
      '[href*="/collections/mens-shoes"], [href*="/collections/womens-shoes"]'
    );
    collectionMenuItems.forEach((menuItem) => {
      if (menuItem.href.indexOf("?") == -1) {
        menuItem.href += `?${exp_url_param}`;
      }
    });
    shopAllItems.forEach((menuItem) => {
      if (menuItem.href.indexOf("?") == -1) {
        menuItem.href += `?${exp_url_param}-shopall`;
      }
    });

    //Define menu element based on if mobile or desktop
    const isMobile = checkIfMobile();
    const imageSelector = isMobile ? 1 : 0;
    waitElement = isMobile
      ? ".mobile-nav ul li a img"
      : ".menu.mega-menu ul li a img";

    //Wait for menu images to load
    waitForElement(waitElement).then((el) => {
      //Create male and female menu image variables
      const mensaAthensImg = el
        .closest("nav-menu")
        .querySelectorAll('li a[href*="/mens-athens"]');
      const womensaAthensImg = el
        .closest("nav-menu")
        .querySelectorAll('li a[href*="/womens-athens"]');
      const mensaLimaImg = el
        .closest("nav-menu")
        .querySelectorAll('li a[href*="/mens-lima"]');
      const womensaLimaImg = el
        .closest("nav-menu")
        .querySelectorAll('li a[href*="/womens-lima"]');
      const mensPragueImg = el
        .closest("nav-menu")
        .querySelectorAll('li a[href*="/mens-prague"]');
      const womensPragueImg = el
        .closest("nav-menu")
        .querySelectorAll('li a[href*="/womens-prague"]');
      const mensMadridImg = el
        .closest("nav-menu")
        .querySelectorAll('li a[href*="/mens-madrid-eco-knit-graphite"]');
      const womensMadridImg = el
        .closest("nav-menu")
        .querySelectorAll('li a[href*="/womens-madrid-eco-knit-pebble-grey"]');

      //Replace menu images based on variant value
      switch (exp_var) {
        case "v1":
          womensaAthensImg[imageSelector].querySelector("img").src =
            "https://cld.accentuate.io/278071672989/1663681631268/Athens_Black_Black_Profile_Outer_2048.png?v=1663681631268&options=w_180";
          womensaAthensImg[imageSelector].href =
            window.location.origin +
            "/products/womens-athens-black-black-outsole";

          womensaLimaImg[imageSelector].querySelector("img").src =
            "https://cld.accentuate.io/283916664989/1663077288194/Lima_Grey_Profile_Outer_20489.png?v=1663077288194&options=w_180";

          womensaLimaImg[imageSelector].href =
            window.location.origin + "/products/womens-lima-grey";

          womensMadridImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/women-madrid-menu-v1.png?v=1688500607";

          womensMadridImg[imageSelector].href =
            window.location.origin +
            "/products/womens-madrid-eco-knit-marshmallow";

          mensPragueImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-prague-men-v1.png?v=1688500864";

          mensPragueImg[imageSelector].href =
            window.location.origin +
            "/products/mens-prague-black-black-outsole";

          womensPragueImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/womens-prague-menu-v1.png?v=1688501257";

          womensPragueImg[imageSelector].href =
            window.location.origin + "/products/womens-prague-bone";
          break;

        case "v2":
          mensaAthensImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-athens-menu-v2.png?v=1688586165";

          mensaAthensImg[imageSelector].href =
            window.location.origin + "/products/mens-athens-deep-sea";

          womensaAthensImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/womens-athens-menu-v2.png?v=1688586165";

          mensaLimaImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-lima-menu-v2.png?v=1688587745";

          mensaLimaImg[imageSelector].href =
            window.location.origin + "/products/mens-lima-tidepool";

          womensaLimaImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/womens-athens-menu-v2_028e4a32-b2d9-4f26-946c-572e117f3209.png?v=1688589069";

          womensaLimaImg[imageSelector].href =
            window.location.origin + "/products/womens-lima-fawn";

          mensMadridImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-madrid-menu-v2.png?v=1688588063";

          mensMadridImg[imageSelector].href =
            window.location.origin + "/products/mens-madrid-eco-knit-olive";

          womensMadridImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/womens-ecoknit-menu-v2.png?v=1688589567";

          womensMadridImg[imageSelector].href =
            window.location.origin + "/products/womens-madrid-eco-knit-olive";

          // mensPragueImg[imageSelector].querySelector("img").src = "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-prague-menu-v2.png?v=1688588407";

          mensPragueImg[imageSelector].href =
            window.location.origin + "/products/mens-prague-dusk-blue";

          womensPragueImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/womens-mauve-menu-v2.png?v=1688589373";

          womensPragueImg[imageSelector].href =
            window.location.origin + "/products/womens-prague-mauve";

          break;
        case "v3":
          mensaAthensImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-athens-menu-v3.png?v=1688586165";

          mensaAthensImg[imageSelector].href =
            window.location.origin + "/products/mens-athens-crimson";

          womensaAthensImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/womens-athens-menu-v2.png?v=1688586165";

          mensaLimaImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-lima-menu-v3.png?v=1688590164";

          mensaLimaImg[imageSelector].href =
            window.location.origin + "/products/mens-lima-spearmint";

          womensaLimaImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/womens-spearmint-menu-v3.png?v=1688590864";

          womensaLimaImg[imageSelector].href =
            window.location.origin + "/products/womens-lima-spearmint";

          mensMadridImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-madrid-menu-v3.png?v=1688590351";

          mensMadridImg[imageSelector].href =
            window.location.origin + "/products/mens-madrid-eco-knit-sage";

          womensMadridImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-madrid-menu-v3.png?v=1688590351";

          womensMadridImg[imageSelector].href =
            window.location.origin + "/products/womens-madrid-eco-knit-sage";

          mensPragueImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-creme-brulee-menu-v3.png?v=1688590548";

          mensPragueImg[imageSelector].href =
            window.location.origin + "/products/mens-prague-creme-brulee";

          womensPragueImg[imageSelector].querySelector("img").src =
            "https://cdn.shopify.com/s/files/1/2281/1461/files/mens-creme-brulee-menu-v3.png?v=1688590548";

          womensPragueImg[imageSelector].href =
            window.location.origin + "/products/womens-prague-creme-brulee";
          break;
        default:
        // code block
      }
    });
  })
  .catch();

/* ----------

// END KIZ-11

---------- */

// [KIZ-36] Back to school banners
// v1: banners
// v2: cart-drawer

waitUntil(() => {
  return (
    window.sessionStorage.getItem("KIZ-36") ||
    getParam("exp").indexOf("KIZ-36") > -1
  );
})
  .then(() => {
    let experiment = "KIZ-36";
    let variation = window.sessionStorage.getItem(experiment);

    if (getParam("exp") && getParam("var")) {
      variation = getParam("var");
    } else if (window.sessionStorage.getItem(experiment)) {
      variation = window.sessionStorage.getItem(experiment);
    }

    console.log(`init [${experiment}] -- 0.01 -- ${variation}`);

    waitForElement("body")
      .then((doc) => {
        doc.insertAdjacentHTML(
          "afterbegin",
          `
  
          <style>

          .js-kz36--discount-msg{
            display: block !important;
          }

          .js-kz36--discount-msg--default{
            display: block !important;
          }
          
          #collection-custom-banner{
            font-size:2.5rem;
          }
          #pdp-custom-banner{
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
            font-weight:bold;
          }
          .product-hero-card{
            border-top-right-radius: 0;
            border-top-left-radius: 0;
          }
            .custom-banner{
              background-color:#ffbf00;
              padding:1rem;
            }
            .mega-menu .custom-banner{
              height:112px;
            }
            .mega-menu .custom-banner a{
              height:100%;
            }
            @media(min-width:768px){
              .mega-menu .custom-banner:hover{
                background-color:#36f !important;
                color:white;
              }
            }
            @media(max-width:768px){
              #pdp-custom-banner{
                border-top-right-radius: 0px;
              border-top-left-radius: 0px;
              font-weight: bold;
              font-size: 1.2rem;
              text-align: center;
              }
              .mobile-nav .custom-banner{
                text-align:center;
                font-size:1.2rem;
              }
            }
            @media(max-width:850px){
              #collection-custom-banner{
                font-size:1.2rem;
                text-align:center;
              }
            }
          </style>
  
        `
        );
      })
      .catch();
    //Banners added to collections pages
    const currentURL = window.location.href;

    if (
      currentURL.includes("collections/kids-collection") ||
      currentURL.includes("collections/kids-shoes")
    ) {
      waitForElement(".collection-grid")
        .then((collectionGrid) => {
          collectionGrid.insertAdjacentHTML(
            "afterBegin",
            `
        <div class="custom-banner" id="collection-custom-banner"><p>Kid's prague, half off with purchase of any adult shoe!</p></div>
        `
          );
        })
        .catch();
    }
    //Banners added to Prague PDP
    if (currentURL.includes("kids-prague")) {
      waitForElement(".product-hero-card")
        .then((productCard) => {
          productCard.insertAdjacentHTML(
            "beforeBegin",
            `
          <div class="custom-banner" id="pdp-custom-banner">Kid's prague, half off with purchase of any adult shoe!</div>
        `
          );
        })
        .catch();
    }
    //Menu banners
    const isMobile = checkIfMobile();
    const menuLinkItem = isMobile
      ? '.fullscreen-navigation .mobile-nav ul li a[href="/products/kids-prague"]'
      : '.mega-menu .nav-list ul li a[href="/products/kids-prague"]';
    waitForElement(menuLinkItem)
      .then((kidsPragueLinkElement) => {
        if (isMobile) {
          const kidsPragueParentButton =
            kidsPragueLinkElement.closest(".mobile-nav");
          kidsPragueParentButton
            .querySelector("button span")
            .insertAdjacentHTML(
              "afterEnd",
              `
        <div class="pill top-2 left-2 md:top-4 md:left-4 bg-yellow z-[1]">Back to School Deal</div>
        `
            );
        } else {
        }
        const kidsPragueListItem = kidsPragueLinkElement.closest("li");
        kidsPragueListItem.classList.remove("last:mb-8");
        kidsPragueListItem.insertAdjacentHTML(
          "afterEnd",
          `
        <li class="mb-2 custom-banner rounded-md" data-index="1">
                
                
        <a href="/products/kids-prague" class="flex items-center justify-between gap-4">
          <div>
            <div class="dk:text-xl pb-1 font-normalbold collection-nav-title pb-2">Kid's prague, half off with purchase of any adult shoe!</div>
          </div>
        </a>
        
        </li>
        `
        );
      })
      .catch();
    //V2 Add banner to cart drawer
    if (variation == "v2") {
      observeSelector('cart-wrapper [name="checkout"]', (checkoutButton) => {
        checkoutButton.insertAdjacentHTML(
          "afterEnd",
          `
        <button class="custom-banner btn w-full mt-2">Back to School Deal! Kid's Prague.</button>
        `
        );
        console.log(checkoutButton);
      });
    }
  })
  .catch();

/**/

/* ----------
START WINNING PERSONALIZATIONS
---------- */

waitForElement('body').then(doc => {
  let exp_id = "KIZ-32A";
  let exp_var = "v1";
  console.log(`init [${exp_id}] -- 0.1 -- ${exp_var}`);
  
  doc.insertAdjacentHTML("afterbegin", `
    <style>
    .cc-window.cc-banner {
      font-size : 1rem !important;
      padding-right: 3rem;
    }
    </style>
  `);
}).catch();

/*
waitForElement('body').then(doc => {
  let exp_id = "KIZ-32B";
  let exp_var = "v1";
  console.log(`init [${exp_id}] -- 0.2 -- ${exp_var}`);
  
  doc.insertAdjacentHTML("afterbegin", `
    <style>
    .cc-window.cc-banner:not(.js-active) {
      display: none !important;
    }
    </style>
  `);
  
  setTimeout(() => {
    document.querySelector('.cc-window.cc-banner').classList.add("js-active");
  }, 10000)
}).catch();
*/

/* ----------

// [KIZ - XX] ---> EXPERIMENT NAME <---
// v1: ---> VARIATION NAME <---
// Notes:
// brief description of what this code snippet is going to achieve so we don't have to go cross-reference in our task management system to look it up.

/* ----------

// START experiment template

// [KIZ - XX] ---> EXPERIMENT NAME <---
// v1: ---> VARIATION NAME <---
// Notes:
// brief description of what this code snippet is going to achieve so we don't have to go cross-reference in our task management system to look it up.

waitUntil(() => {
  return window.sessionStorage.getItem("KIZ-XX") || getParam("exp").indexOf("KIZ-XX") > -1;
}).then(() => {

  let experiment = "KIZ-XX";
  let variation = "v1";

  if(getParam("exp") && getParam("var")){
    variation = getParam("var");
  } else if(window.sessionStorage.getItem(experiment)){
    variation = window.sessionStorage.getItem(experiment);
  }

  window.sessionStorage.setItem(experiment, variation);
  console.log(`init [${experiment}] -- 0.01 -- ${variation}`);

  waitForElement('body').then(doc => {

    if(variation == "v1"){
      doc.insertAdjacentHTML("afterbegin", `

        <style>


        </style>

      `);
    }

    if(variation == "v2"){
      doc.insertAdjacentHTML("afterbegin", `

        <style>

        </style>

      `);

    }

  }).catch();

}).catch();

// END experiment template
---------- */

/*
[KIZ-P01]
add PDP-specific sizing/fit messaging
*/

const size_info_items = [
  {
    url_partial: "/products/womens-juno-mid",
    size: "small",
    product_name: "The Juno Mid",
    fit_description: "narrow fit",
    fit_amount: "one"
  },
  {
    url_partial: "/products/womens-juno",
    size: "small",
    product_name: "The Juno",
    fit_description: "narrow fit",
    fit_amount: "one"
  },{
    url_partial: "/products/mens-juno",
    size: "small",
    product_name: "The Juno",
    fit_description: "narrow fit",
    fit_amount: "one" 
  },{
    url_partial: "/products/mens-milan",
    size: "small",
    product_name: "The Milan",
    fit_description: "narrow fit",
    fit_amount: "one-half" 
  },{    
    url_partial: "/products/womens-milan",
    size: "small",
    product_name: "The Milan",
    fit_description: "narrow fit",
    fit_amount: "one-half"  
  },{
    url_partial: "/products/womens-roamer",
    size: "large",
    product_name: "The Roamer",
    fit_description: "roomy fit",
    fit_amount: "one-half"  
  },{
    url_partial: "/products/mens-roamer",
    size: "large",
    product_name: "The Roamer",
    fit_description: "roomy fit",
    fit_amount: "one-half"  
  },
];

for(let i = 0; i < size_info_items.length; i++){
  if(window.location.href.indexOf(size_info_items[i].url_partial) > -1){

    waitForElement('.pdp--size-info').then(size_info => {
      size_info.setAttribute("data-size-info", size_info_items[i].size)
      size_info.insertAdjacentHTML("beforebegin", `
      <style>
      .pdp--size-info{
        width: 100%;
        padding: 1.5rem;
        border-radius: 10px;
        background: #f1f1f1;
        border: 2px solid #000;
        margin-top: .75rem;
      }

      .pdp--size-info[data-size-info="small"] span.runs-large,
      .pdp--size-info[data-size-info="large"] span.runs-small{
        display: none;
      }

      .pdp--size-info[data-size-info="small"] div.runs-small,
      .pdp--size-info[data-size-info="large"] div.runs-large{
        font-weight: 900;
      }

      .js-row{
        display:flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }
      .pdp--size-info--chart > .js-col{
        background: #fff;
        padding: 5px 0;
        border: 1px solid #000;
      }
    
      .pdp--size-info--chart > .js-col:not(:first-child){
        border-left: 0;
      }
    
      .pdp--size-info--labels > .js-col{
        text-align: center;
        padding-top: .75rem;
      }
    
      .pdp--size-info--dot{
        padding: 12px;
        transform: translateX(-50%);
        position: absolute;
        border-radius: 100%;
        background: #000;
      }
      </style>
      `);
      size_info.innerHTML = `
        <h3 class="h3 text-[18px] font-medium pt-3">
          How do they fit?
        </h3>
        <p class="body-small py-3 mt-1">
          ${size_info_items[i].product_name} has a ${size_info_items[i].fit_description}. If you're between sizes, we recommend ordering ${size_info_items[i].fit_amount} size <span class="runs-small">up</span><span class="runs-large">down</span>.
        </p>
        <div class="pdp--size-info--chart js-row">
          <div class="js-col" style="width:25%; border-radius: 10px 0 0 10px;"></div>
          <div class="js-col" style="width:25%;"></div>
          <div class="js-col" style="width:25%;"></div>
          <div class="js-col" style="width:25%; border-radius: 0 10px 10px 0;"></div>
          <div class="pdp--size-info--dot" style="left: calc(${size_info_items[i].size == "small" ? 25 : 75}%);"></div>
        </div>
        <div class="pdp--size-info--labels js-row">
          <div class="js-col" style="width:12.5%;"></div>
          <div class="js-col body-small runs-small" style="width:25%;">RUNS<br>SMALL</div>
          <div class="js-col body-small" style="width:25%;">RUNS<br>TRUE</div>
          <div class="js-col body-small runs-large" style="width:25%;">RUNS<br>LARGE</div>
          <div class="js-col" style="width:12.5%;"></div>
        </div>
      `;
    }).catch();
    break;
  }
}